import { t } from 'i18next';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import type { PhoneNumber } from 'react-phone-number-input';

import { Text } from '@/ui';

const countryCodeToFlagEmoji = (countryCode: string) =>
  countryCode
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));

interface ExistingPhoneDisplayProps {
  phone: PhoneNumber | null;
}

export function ExistingPhoneDisplay({ phone }: ExistingPhoneDisplayProps) {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.phoneRow}>
      <View style={styles.disabledField}>
        <Text type="caption1" style={styles.disabledLabel}>
          {t('entry.countryLabel')}
        </Text>
        <View style={styles.disabledInput}>
          <Text type="bodyRegular" style={styles.disabledText}>
            {phone
              ? `${countryCodeToFlagEmoji(phone.country ?? '')} +${
                  phone.countryCallingCode
                }`
              : ''}
          </Text>
        </View>
      </View>
      <View style={[styles.disabledField, { flex: 1 }]}>
        <Text type="caption1" style={styles.disabledLabel}>
          {t('entry.phoneLabel')}
        </Text>
        <View style={styles.disabledInput}>
          <Text type="bodyRegular" style={styles.disabledText}>
            {phone?.nationalNumber ?? ''}
          </Text>
        </View>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  phoneRow: {
    flexDirection: 'row',
    gap: 8,
  },
  disabledField: {
    gap: 8,
  },
  disabledLabel: {
    color: theme.colors.input.disabled.text,
  },
  disabledInput: {
    height: 48,
    minWidth: 96,
    justifyContent: 'center',
    paddingHorizontal: 16,
    borderRadius: 16,
    backgroundColor: theme.colors.input.disabled.fill,
    borderWidth: 1,
    borderColor: theme.colors.input.disabled.border,
  },
  disabledText: {
    color: theme.colors.input.disabled.text,
  },
}));
